(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFeaturedProductForm(form) {
      var section = form.closest('.featured-product-spotlight');
      var variantsScript = section.querySelector('[data-featured-product-variants]');
      if (!variantsScript) return;

      var variants = JSON.parse(variantsScript.textContent);
      var selects = Array.prototype.slice.call(
        form.querySelectorAll('[data-featured-product-option-selector]')
      );
      var idInput = form.querySelector('[data-featured-product-variant-id]');
      var submitButton = form.querySelector('[data-featured-product-submit]');
      var priceWrap = section.querySelector('[data-featured-product-price]');

      function findMatchingVariant() {
        var selected = selects.map(function (select) {
          return select.value;
        });
        return variants.find(function (variant) {
          var options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
          return selected.every(function (value, index) {
            return options[index] === value;
          });
        });
      }

      function render(variant) {
        if (!variant) {
          submitButton.disabled = true;
          submitButton.textContent = 'Unavailable';
          return;
        }

        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));

        if (variant.available) {
          submitButton.disabled = false;
          submitButton.textContent = submitButton.dataset.defaultLabel || submitButton.textContent;
        } else {
          submitButton.disabled = true;
          submitButton.textContent = 'Sold out';
        }

        if (priceWrap) {
          var current = priceWrap.querySelector('.featured-product-spotlight__price-current');
          if (current) current.textContent = formatMoney(variant.price);
        }
      }

      function formatMoney(cents) {
        return (cents / 100).toLocaleString(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD',
        });
      }

      if (submitButton && !submitButton.dataset.defaultLabel) {
        submitButton.dataset.defaultLabel = submitButton.textContent;
      }

      selects.forEach(function (select) {
        select.addEventListener('change', function () {
          render(findMatchingVariant());
        });
      });
    }

    function initGallery(section) {
      var track = section.querySelector('[data-gallery-track]');
      if (!track) return;

      var slides = Array.prototype.slice.call(section.querySelectorAll('[data-gallery-slide]'));
      var dots = Array.prototype.slice.call(section.querySelectorAll('[data-gallery-dot]'));
      var activeIndex = 0;

      function setActive(index) {
        activeIndex = index;
        dots.forEach(function (dot, dotIndex) {
          if (dotIndex === index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      function scrollToIndex(index) {
        var clamped = Math.max(0, Math.min(index, slides.length - 1));
        slides[clamped].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                var index = slides.indexOf(entry.target);
                if (index !== -1) setActive(index);
              }
            });
          },
          { root: track, threshold: 0.6 }
        );
        slides.forEach(function (slide) {
          observer.observe(slide);
        });
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          scrollToIndex(index);
        });
      });

      var isDown = false;
      var startX = 0;
      var startScrollLeft = 0;

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch') return;
        isDown = true;
        startX = event.clientX;
        startScrollLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener('pointermove', function (event) {
        if (!isDown) return;
        var delta = event.clientX - startX;
        track.scrollLeft = startScrollLeft - delta;
      });

      function endDrag() {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        scrollToIndex(activeIndex);
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', function () {
        if (isDown) endDrag();
      });
    }

    document.querySelectorAll('[data-featured-product-form]').forEach(initFeaturedProductForm);
    document.querySelectorAll('.featured-product-spotlight').forEach(initGallery);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initDragScroll(track) {
      var isDown = false;
      var startX = 0;
      var startScrollLeft = 0;

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch') return;
        isDown = true;
        startX = event.clientX;
        startScrollLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener('pointermove', function (event) {
        if (!isDown) return;
        var delta = event.clientX - startX;
        track.scrollLeft = startScrollLeft - delta;
      });

      function endDrag() {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', function () {
        if (isDown) endDrag();
      });
    }

    document.querySelectorAll('.ingredient-cards__grid').forEach(initDragScroll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-modal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-modal-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var dialog = document.getElementById(trigger.dataset.modalTrigger);
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      });
    });

    document.querySelectorAll('[data-modal-dialog]').forEach(function (dialog) {
      var closeButton = dialog.querySelector('[data-modal-close]');
      if (closeButton) {
        closeButton.addEventListener('click', function () {
          dialog.close();
        });
      }

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBuyboxGallery(root) {
      var track = root.querySelector('[data-gallery-track]');
      if (!track) return;

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-slide]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-dot]'));
      var activeIndex = 0;

      function setActive(index) {
        activeIndex = index;
        thumbs.forEach(function (thumb, thumbIndex) {
          if (thumbIndex === index) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }

      function scrollToIndex(index) {
        var clamped = Math.max(0, Math.min(index, slides.length - 1));
        slides[clamped].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                var index = slides.indexOf(entry.target);
                if (index !== -1) setActive(index);
              }
            });
          },
          { root: track, threshold: 0.6 }
        );
        slides.forEach(function (slide) {
          observer.observe(slide);
        });
      }

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
          scrollToIndex(index);
        });
      });

      var isDown = false;
      var startX = 0;
      var startScrollLeft = 0;

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch') return;
        isDown = true;
        startX = event.clientX;
        startScrollLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener('pointermove', function (event) {
        if (!isDown) return;
        var delta = event.clientX - startX;
        track.scrollLeft = startScrollLeft - delta;
      });

      function endDrag() {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        scrollToIndex(activeIndex);
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', function () {
        if (isDown) endDrag();
      });
    }

    document.querySelectorAll('.pdp-buybox').forEach(initBuyboxGallery);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initResultsGallery(root) {
      var track = root.querySelector('[data-carousel-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
      var prevButton = root.querySelector('[data-carousel-prev]');
      var nextButton = root.querySelector('[data-carousel-next]');
      if (!track || slides.length === 0) return;

      var activeIndex = 0;

      function setActive(index) {
        activeIndex = index;
        dots.forEach(function (dot, dotIndex) {
          if (dotIndex === index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
        if (prevButton) prevButton.disabled = index === 0;
        if (nextButton) nextButton.disabled = index === slides.length - 1;
      }

      function scrollToIndex(index) {
        var clamped = Math.max(0, Math.min(index, slides.length - 1));
        slides[clamped].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                var index = slides.indexOf(entry.target);
                if (index !== -1) setActive(index);
              }
            });
          },
          { root: track, threshold: 0.6 }
        );
        slides.forEach(function (slide) {
          observer.observe(slide);
        });
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          scrollToIndex(index);
        });
      });

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          scrollToIndex(activeIndex - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          scrollToIndex(activeIndex + 1);
        });
      }

      var isDown = false;
      var hasDragged = false;
      var startX = 0;
      var startScrollLeft = 0;

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch') return;
        isDown = true;
        hasDragged = false;
        startX = event.clientX;
        startScrollLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener('pointermove', function (event) {
        if (!isDown) return;
        var delta = event.clientX - startX;
        if (Math.abs(delta) > 5) hasDragged = true;
        track.scrollLeft = startScrollLeft - delta;
      });

      function endDrag() {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        scrollToIndex(activeIndex);
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', function () {
        if (isDown) endDrag();
      });

      track.addEventListener(
        'click',
        function (event) {
          if (hasDragged) {
            event.preventDefault();
            event.stopPropagation();
            hasDragged = false;
          }
        },
        true
      );

      setActive(0);
    }

    document.querySelectorAll('.results-gallery').forEach(initResultsGallery);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["routine-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initDragScroll(track) {
      var isDown = false;
      var startX = 0;
      var startScrollLeft = 0;

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch') return;
        isDown = true;
        startX = event.clientX;
        startScrollLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener('pointermove', function (event) {
        if (!isDown) return;
        var delta = event.clientX - startX;
        track.scrollLeft = startScrollLeft - delta;
      });

      function endDrag() {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', function () {
        if (isDown) endDrag();
      });
    }

    document.querySelectorAll('.routine-timeline__track').forEach(initDragScroll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["step-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initStepCarousel(root) {
      var track = root.querySelector('[data-carousel-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
      var prevButton = root.querySelector('[data-carousel-prev]');
      var nextButton = root.querySelector('[data-carousel-next]');
      if (!track || slides.length === 0) return;

      var activeIndex = 0;

      function setActive(index) {
        activeIndex = index;
        dots.forEach(function (dot, dotIndex) {
          if (dotIndex === index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
        if (prevButton) prevButton.disabled = index === 0;
        if (nextButton) nextButton.disabled = index === slides.length - 1;
      }

      function scrollToIndex(index) {
        var clamped = Math.max(0, Math.min(index, slides.length - 1));
        slides[clamped].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                var index = slides.indexOf(entry.target);
                if (index !== -1) setActive(index);
              }
            });
          },
          { root: track, threshold: 0.6 }
        );
        slides.forEach(function (slide) {
          observer.observe(slide);
        });
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          scrollToIndex(index);
        });
      });

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          scrollToIndex(activeIndex - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          scrollToIndex(activeIndex + 1);
        });
      }

      var isDown = false;
      var hasDragged = false;
      var startX = 0;
      var startScrollLeft = 0;

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch') return;
        isDown = true;
        hasDragged = false;
        startX = event.clientX;
        startScrollLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener('pointermove', function (event) {
        if (!isDown) return;
        var delta = event.clientX - startX;
        if (Math.abs(delta) > 5) hasDragged = true;
        track.scrollLeft = startScrollLeft - delta;
      });

      function endDrag() {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        scrollToIndex(activeIndex);
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', function () {
        if (isDown) endDrag();
      });

      track.addEventListener(
        'click',
        function (event) {
          if (hasDragged) {
            event.preventDefault();
            event.stopPropagation();
            hasDragged = false;
          }
        },
        true
      );

      setActive(0);
    }

    document.querySelectorAll('.step-carousel').forEach(initStepCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cart-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function revealOnScroll(bar) {
      var ratio = parseFloat(bar.dataset.revealRatio);
      if (isNaN(ratio) || ratio <= 0) ratio = 0.6;

      function update() {
        var past = window.scrollY > window.innerHeight * ratio;
        bar.classList.toggle('is-visible', past);
      }

      window.addEventListener('scroll', update, { passive: true });
      update();
    }

    function initStickyCartBar(bar) {
      var selector = bar.dataset.watchSelector;
      var watchTarget = selector ? document.querySelector(selector) : null;

      if (!watchTarget || !('IntersectionObserver' in window)) {
        revealOnScroll(bar);
        return;
      }

      new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', scrolledPast);
        },
        { threshold: 0 }
      ).observe(watchTarget);
    }

    document.querySelectorAll('[data-sticky-cart-bar]').forEach(initStickyCartBar);
  })();

  } catch(e) { console.error(e); }
})();
})();
